module.exports = __webpack_public_path__ + "static/img/yljx.24eee0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yljx.jpg
// module id = iz7R
// module chunks = 1